import React from 'react';
import { Html } from 'cccisd-wysiwyg';

const HtmlRender = ({ widget }) => <Html content={widget.htmlContent} />;

export default HtmlRender;
